import PropTypes from 'prop-types';
import React from 'react';
import {
  Drawer,
  withStyles,
} from '@material-ui/core';
import grey from '@material-ui/core/colors/grey';

import Breakpoint from 'ondemand/components/Breakpoint';
import CornerButton from 'ondemand/components/CornerButton';
import MenuIcon from 'common/components/icons/HamburgerIcon';

const styles = () => ({
  root: {
    backgroundColor: grey[900],
    height: '100%',
    width: '220px',
  },
  content: {
    position: 'relative',
    height: '100%',
    transition: 'margin 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  },
  dockedMenu: {
    marginLeft: '220px',
  },
  container: {
    height: '100%',
    backgroundColor: grey[700],
  }
});

class ResponsiveDrawerLayout extends React.PureComponent {
  static displayName = 'ResponsiveDrawerLayout';

  static propTypes = {
    children: PropTypes.node,
    drawerContent: PropTypes.node,
    hideHamburger: PropTypes.bool,
    mobileMax: PropTypes.number.isRequired,
    open: PropTypes.bool,
    classes: PropTypes.object,
  };

  static defaultProps = {
    open: null,
  };

  state = {
    open: this.props.open !== null ? this.props.open : false,
  };

  _handleDrawerToggle = () => {
    this.setState({open: !this.state.open});
  };

  render() {
    return (
      <Breakpoint maxWidth={this.props.mobileMax}>
        {(isMobile) => {
          const marginLeft = isMobile ? 0 : '220px';
          const menuButton = !isMobile || this.props.hideHamburger ? null : (
            <CornerButton onClick={this._handleDrawerToggle} zIndex={10} data-id="hamburger-button">
              <MenuIcon />
            </CornerButton>
          );
          return (
            <div className={this.props.classes.container}>
              <Drawer
                variant={isMobile ? 'temporary' : 'persistent'}
                open={!isMobile || this.state.open}
                onClose={this._handleDrawerToggle}
                classes={{
                  paper: this.props.classes.root
                }}
              >
                <div onClick={this._handleDrawerToggle}>
                  {this.props.drawerContent}
                </div>
              </Drawer>
              <div className={this.props.classes.content} style={{marginLeft}}>
                {menuButton}
                {this.props.children}
              </div>
            </div>
          );
        }}
      </Breakpoint>
    );
  }
}

export default withStyles(styles)(ResponsiveDrawerLayout);



// WEBPACK FOOTER //
// ./src/ondemand/components/ResponsiveDrawerLayout.js